// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--2N3du","menuBar":"menu-module--menuBar--10Xxn","logo":"menu-module--logo--2oYMJ","submenu":"menu-module--submenu--2CYYX"};